import React, { useState } from 'react';
import {
  Box,
  TextField,
  Container,
  Typography,
  Button,
  CircularProgress,
  InputAdornment,
  Grid,
} from '@mui/material';
import { Lock } from '@mui/icons-material';
import Sidebar from '../components/sidebars/sidebar_hod';
import TopNav from '../components/top_bars/TopNav';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import StatisticsCards from '../components/top_bars/StatisticsCard';

const PasswordChangeForm = () => {
  const navigate = useNavigate();

  
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userProfile');
    navigate('/login');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { currentPassword, newPassword, confirmPassword } = formData;

    if (!currentPassword.trim() || !newPassword.trim() || !confirmPassword.trim()) {
      Swal.fire('Validation Error', 'All fields are required.', 'warning');
      return;
    }
    if (newPassword !== confirmPassword) {
      Swal.fire('Validation Error', 'New password and confirm password must match.', 'warning');
      return;
    }

    const email = localStorage.getItem('email');
if (!email) {
  Swal.fire('Error', 'You must be logged in to change your password.', 'error');
  return;
}


    setLoading(true);
    try {
     const response = await axios.post(
  `${process.env.REACT_APP_API_BASE_URL}/change_password.php`,
  {
    email,
    old_password: currentPassword,
    new_password: newPassword,
  }
);

     

      if (response.status === 200) {
        Swal.fire('Success', 'Password changed successfully!', 'success');
        navigate('/dashboard');
      } else {
        const errorMessage =
          response.data.message || 'Failed to change password. Please try again.';
        Swal.fire('Error', errorMessage, 'error');
      }
    } catch (error) {
      console.error('Error details:', error.response ? error.response.data : error.message);

      if (error.response) {
        const errorMsg =
          error.response.data.message || 'Failed to change password. Please try again.';
        Swal.fire('Error', errorMsg, 'error');
      } else if (error.request) {
        Swal.fire(
          'Error',
          'No response from the server. Please check your network connection and try again.',
          'error'
        );
      } else {
        Swal.fire(
          'Error',
          'An error occurred while setting up the request. Please try again.',
          'error'
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          ml: sidebarOpen ? 30 : 5,
          mt: 0,
          maxWidth: '1200px',
          mx: 'auto',
        }}
      >
        <TopNav onLogout={handleLogout} toggleSidebar={toggleSidebar} />
        <Box sx={{ mt: 2 }}>
          <StatisticsCards />
        </Box>

        <Grid container spacing={3} sx={{ mt: 5 }}>
          <Grid item xs={12}>
            <Container
              sx={{
                borderRadius: '8px',
                boxShadow: 3,
                p: 4,
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 'bold', marginBottom: 3, textAlign: 'center' }}
                >
                  Change Your Password
                </Typography>
                <form style={{ width: '100%' }} onSubmit={handleSubmit}>
                  <TextField
                    label="Current Password"
                    variant="outlined"
                    fullWidth
                    type="password"
                    name="currentPassword"
                    value={formData.currentPassword}
                    onChange={handleChange}
                    required
                    sx={{ mb: 3 }}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Lock />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="New Password"
                    variant="outlined"
                    fullWidth
                    type="password"
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleChange}
                    required
                    sx={{ mb: 3 }}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                  />
                  <TextField
                    label="Confirm New Password"
                    variant="outlined"
                    fullWidth
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                    sx={{ mb: 3 }}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth
                    sx={{ height: 50 }}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={24} /> : 'Change Password'}
                  </Button>
                </form>
              </Box>
            </Container>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PasswordChangeForm;